import type { TLabBase1T } from '@team-milva/lab-pdfs'
import { tIn } from '@/locales'

/**
 * Binds vue-i18n to one locale for the lab-pdfs report template.
 *
 * lab-pdfs renders from both lab-cloud (i18next) and here (vue-i18n), so it
 * translates its own chrome through a translator the caller injects rather than
 * importing an i18n runtime itself. Every call site goes through this helper so
 * the preview and the generated PDF cannot drift apart (MIL-268).
 */
export const labBase1TFor =
  (locale: string): TLabBase1T =>
  (key, params) =>
    tIn(locale, key, params)
